<template lang="pug">
  v-app-bar(color='primary' dense dark extended extension-height='30px' fixed app hide-on-scroll)
    v-btn(icon)
      v-icon(@click="vibrate();$router.push('/home')") mdi-arrow-left
    v-toolbar-title.pl-0
      .header(align='center')
        | {{title}}
        restaurant-selector(v-if='true')
    v-spacer
    role-selector(:user='selectedUser')
    template(v-slot:extension)
      v-tabs.pl-2(align-with-title show-arrows dark background-color='primary' @change='tab=$event;openArea(areas[$event])' height='30px' slider-color='yellow')
        v-tab(v-for='(area ,idx) in areas' :key='area.id')
          | {{area.code}}
          span(v-if='idx==tab') : {{ area.name }}
</template>

<script>
import { storeMixin } from "../../mixins/storeMixin.js";
import RoleSelector from "../menus/RoleSelector.vue";
import RestaurantSelector from "../menus/RestaurantSelector.vue";

export default {
  name: "eztoolbar",
  mixins: [storeMixin],
  components: { RoleSelector, RestaurantSelector },
  props: { title: String },
  async beforeMount() {
    this.restaurants.length || this.bindRestaurants();
    this.areas.length || this.bindAreas();
    if (this.$route.params) {
      this.routeParams = this.$route.params;
      let { restaurantId, sectionId, counterId } = this.routeParams;
      if (
        restaurantId &&
        restaurantId !=
          (this.selectedRestaurant ? this.selectedRestaurant.id : null)
      ) {
        this.myRestaurants = await this.allowedRestaurants;
        const restaurant = this.myRestaurants.find(r => r.id === restaurantId);
        this.selectRestaurant(restaurant);
      }
      if (
        sectionId &&
        sectionId != (this.selectedSection ? this.selectedSection.id : null)
      ) {
        const section = this.mySections.find(s => s.id === sectionId);
        this.selectSection(section);
      }
      if (
        counterId &&
        counterId != (this.selectedCounter ? this.selectedCounter.id : null)
      ) {
        const counter = this.myCounters.find(c => c.id === counterId);
        this.selectCounter(counter);
      }
    }
  },
  data() {
    return {
      myRestaurants: [],
      tab: 0,
      routeParams: {},
      isCounterOpen: false
    };
  },
  computed: {
    areas() {
      let areas = [];
      switch (this.$route.name) {
        case "services":
          if (this.myFeatures.eligibleFeatures.includes("REPORT")) {
            areas = [...this.mySections];
            if (
              ["GA", "RM"].includes(this.selectedUser && this.selectedUser.role)
            ) {
              areas = [{ code: "All", name: "Restaurant" }, ...areas];
            }
          } else {
            areas = [{ code: "All", name: "Restaurant" }];
          }
          break;
        case "sectionServices":
        case "sectionService":
          areas = [this.selectedSection];
          break;
        case "orders":
          if (this.myFeatures.eligibleFeatures.includes("REPORT")) {
            areas = [...this.myCounters, ...this.mySections];
            if (
              ["GA", "RM"].includes(this.selectedUser && this.selectedUser.role)
            ) {
              areas = [{ code: "All", name: "Restaurant" }, ...areas];
            }
          } else {
            areas = [{ code: "All", name: "Restaurant" }];
          }
          break;
        case "sectionOrders":
          areas = [this.selectedSection];
          break;
        case "counterOrders":
          areas = [this.selectedCounter];
          break;
        case "inventory":
          if (this.myFeatures.eligibleFeatures.includes("REPORT")) {
            areas = [...this.myCounters];
            if (
              ["GA", "RM"].includes(this.selectedUser && this.selectedUser.role)
            ) {
              areas = [{ code: "All", name: "Restaurant" }, ...areas];
            }
          } else {
            areas = [{ code: "All", name: "Restaurant" }];
          }
          break;
        case "counterInventory":
          areas = [this.selectedCounter];
          break;
        case "reports":
          if (this.myFeatures.eligibleFeatures.includes("REPORT")) {
            areas = [...this.myCounters, ...this.mySections];
            if (
              ["GA", "RM"].includes(this.selectedUser && this.selectedUser.role)
            ) {
              areas = [{ code: "All", name: "Restaurant" }, ...areas];
            }
          } else {
            areas = [{ code: "All", name: "Restaurant" }];
          }
          break;
        case "sectionReports":
          areas = [this.selectedSection];
          break;
        case "counterReports":
          areas = [this.selectedCounter];
          break;
        default:
          if (this.myFeatures.eligibleFeatures.includes("REPORT")) {
            areas = [...this.myCounters, ...this.mySections];
            if (
              ["GA", "RM"].includes(this.selectedUser && this.selectedUser.role)
            ) {
              areas = [{ code: "All", name: "Restaurant" }, ...areas];
            }
          } else {
            areas = [{ code: "All", name: "Restaurant" }];
          }
      }
      return areas;
    }
  },
  methods: {
    formatHeader(restaurant) {
      let r = restaurant || this.selectedRestaurant;
      return r ? r.code + ", " + r.name + ", " + r.addressLine2 : "Loading...";
    },
    bindAreas() {
      this.bindSections();
      this.bindCounters();
      this.$forceUpdate();
    },
    openArea(area) {
      //!! if the area contains tables that means it is a section, otherwise counter
      // Not neat, but works!!
      if (area) {
        this.isCounterOpen = !area.tables;
        if (area.code === "All") {
          this.$emit("allSelected", area);
        } else if (this.isCounterOpen) {
          this.selectCounter(area);
          this.$emit("counterSelected", area);
        } else {
          this.selectSection(area);
          this.$emit("sectionSelected", area);
        }
        this.$forceUpdate();
      }
    }
  },
  watch: {
    selectedGroup() {
      this.bindRestaurants();
    },
    selectedRestaurant() {
      this.bindAreas();
    }
  }
};
</script>
<style >
.header {
  float: right;
  max-width: 100%;
}
.centered {
  text-align: center;
}
.v-tab {
  text-transform: none;
  padding: 0px;
}
</style>
